import { sortBy } from 'lodash'
import { BrandsLibraryColumnProps } from '@/state/user/models'
import { useBrandsTable } from '@/views/users/hooks/use-brands-table.hook'

import { useBonusDialog } from '@/views/bonus-engine/hooks'
import { DialogsEnum } from '@/enums'
import { TableGenericComponent } from '@/views/components'

import { BrandsFormComponent, BrandsTableRowComponent, BrandsFilters } from './'

export const BrandsTableComponent = () => {
  const {
    headCells,
    brands,
    brandFilters,
    handleBrandFilters,
    handleDeleteBrand,
    handleEditBrand,
  } = useBrandsTable()

  const { dialog } = useBonusDialog()

  const sortedRows = sortBy(brands, 'name')

  const body = sortedRows.map((row: BrandsLibraryColumnProps) => {
    return (
      <BrandsTableRowComponent
        key={row.siteId}
        row={row}
        handleDeleteBrand={handleDeleteBrand}
        handleEditBrand={handleEditBrand}
      />
    )
  })

  return (
    <>
      <BrandsFilters
        filters={brandFilters}
        handleChangeFilter={handleBrandFilters}
      />
      <TableGenericComponent<BrandsLibraryColumnProps>
        headCells={headCells}
        rowLength={sortedRows.length}
        isLoading={false}
        body={body}
        hasAction={true}
      />
      {dialog.open && dialog.id === DialogsEnum.DIALOG_BRAND_FORM && (
        <BrandsFormComponent />
      )}
    </>
  )
}
